import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withFormik } from 'formik';

import { toVw } from '../utils/styles';
import api from '../utils/api';
import InputText from './InputText';
import { inject, observer } from 'mobx-react/index';
import { emailIsCorrect } from '../utils/validators';
import mq from '@/utils/media-queries';

const STATUS_SENT = 'sent';

const Input = styled(InputText)`
  width: ${toVw(864)};

  input {
    color: ${props => props.theme.colorText};

    &::placeholder {
      color: ${props => props.theme.colorText};
    }
  }

  ${mq.tablet(css`
    width: 100%;
  `)};
`;

const InnerForm = ({ values, handleChange, handleSubmit, errors, status }) => (
  <form onSubmit={handleSubmit} method="POST">
    <Input
      name="f_email"
      placeholder="Подписаться на новости"
      data-test="menu-input"
      submitType={'go'}
      onChange={handleChange}
      value={values.f_email}
      status={status}
      _error={String(errors.email)}
    />
  </form>
);

InnerForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  status: PropTypes.string,
  errors: PropTypes.object,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const SubscriptionForm = withFormik({
  mapPropsToValues: () => {
    return {
      f_email: '',
    };
  },
  validate: values => {
    const errors = {};

    if (!values.f_email || !emailIsCorrect(values.f_email)) {
      errors.email = true;
    }

    return errors;
  },
  handleSubmit: (values, { setStatus, props: { progressStore } }) => {
    progressStore.turnOn();

    values = {
      ...values,
      catalogue: 4,
      cc: 61,
      sub: 62,
      posting: 1,
      f_Checked: 1,
      nc_token: '584c57e113e76778b0700646510b9a97',
    };

    api
      .subscribeToNews(values)
      .then(
        data => {
          data.json().then(data => console.log(data));
        },
        errors => {
          console.error(errors);
        }
      )
      .then(() => {
        progressStore.turnOff();
        setStatus(STATUS_SENT);
      });
  },
})(InnerForm);

export default inject(stores => ({ progressStore: stores.store.progress }))(observer(SubscriptionForm));



// WEBPACK FOOTER //
// ./src/components/SubscriptionForm.js